import { forwardRef } from 'react';

import { StyledIconButton } from './IconButton.styled';
import { IconButtonProps } from './IconButton.types';

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ size = 'large', ...props }: IconButtonProps, ref) => {
    /*
      TODO: target the nested icon's font size, based on the `size` prop. ie `.MuiIconButton-sizeLarge > .MuiSvgIcon-root`.
      This is probably the more ideal approach, although it might need to be reviewed when we switch to React FontAwesome.
    */
    return <StyledIconButton size={size} {...props} ref={ref} />;
  },
);

IconButton.displayName = 'IconButton';
